import axios from 'axios';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

const ContactForm = () => {
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [message, setMessage] = useState('');

  const clearValues = () => {
    setName('');
    setEmail('');
    setPhoneNumber('');
    setMessage('');
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      setLoading(true);
      axios.defaults.headers.post['Content-Type'] = 'application/json';
      axios.post('https://formsubmit.co/ajax/ppuhkw@wp.pl', {
        _subject: 'Nowa wiadomość od klienta | ZM Kwiecińscy',
        nazwa: name,
        email: email,
        numer: phoneNumber,
        wiadomość: message,
      });
      setLoading(false);
      clearValues();
      toast.success('Wiadomość została wysłana');
    } catch (error) {
      toast.error('Przepraszamy, wystąpił błąd podczas wysyłania wiadomości');
      setLoading(false);
    }
  };

  return (
    <section id="contact-section" className="contact-section">
      <h2 className="container">Skontaktuj się z nami!</h2>
      <div className="contact-options container">
        <div className="contact-form">
          <h3>Użyj formularza kontaktowego</h3>
          <form onSubmit={onSubmit} name="_captcha" value="false">
            {/* <form onSubmit={onSubmit} className="my-form"> */}
            <input
              type="text"
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Imię i nazwisko*"
              required
            />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Adres email*"
              required
            />
            <input
              type="number"
              name="phoneNumber"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="Numer telefonu"
            />
            <textarea
              name="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              cols="30"
              rows="10"
              placeholder="Wiadomość*"
              required
            ></textarea>
            <input
              type="submit"
              value="Wyślij wiadomość"
              className={clsx(
                !loading
                  ? 'bg-[#ab1414] hover:bg-[#6e1010]'
                  : 'bg-[#4b4643] animate-pulse pointer-events-none',
              )}
            />
            {/* <input
              type="hidden"
              className="hidden"
              name="subject"
              value="Nowa wiadomość | ZM Kwiecińscy"
            />
            <input type="checkbox" name="botcheck" className="hidden"></input> */}
            <p>*pole obowiązkowe</p>
          </form>
        </div>
        <div className="contact-info">
          <h3>Skontaktuj się z nami bezpośrednio</h3>
          <p>ppuhkw@wp.pl</p>
          <p className="phone-number1">+48 52 302 0161</p>
          <p className="phone-number2">+48 881 210 836</p>

          <p>
            Zakład Mięsny Kwiecińścy sp.&nbsp;Z&nbsp;o.o. Bożejewiczki <br />{' '}
            ul. Żnińśka 4 88-400 Żnin <br /> NIP: 562 180 81 84 <br /> REGON:
            367849700 <br />
            KRS: 0000686009
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
